import { render, staticRenderFns } from "./FlightTickets.vue?vue&type=template&id=115b53ae&scoped=true"
import script from "./FlightTickets.vue?vue&type=script&lang=js"
export * from "./FlightTickets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115b53ae",
  null
  
)

export default component.exports